export default () => {
  const postFloodlight = (code) => {
    if (window.FLOODLIGHT_TRACKING_FEATURES === 'true') {
      window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: `${window.FLOODLIGHT_ACCOUNT_NUMBER}/webev0/${code}+standard`,
      });
    }
  };

  const postGoogleTag = (payload) => {
    const { action, category } = payload;
    if (window.FLOODLIGHT_TRACKING_FEATURES === 'true') {
      window.gtag('event', action, {
        'event-category': category,
      });
    }
  };

  return [postFloodlight, postGoogleTag];
};
